import TagpayHistory from "./component";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const TagpayHistoryContainer = () => {
  const navigate = useNavigate();
  const { uId } = useParams();
  const { makeApiRequest } = useApiRequest();

  const [loader, setLoader] = useState(false);
  const [tagListHistory, setTagHistory] = useState([]);
  const [tagDeatils, setTagDeatils] = useState();
  const [tagBalance, setTagBalance] = useState();
  const [cardType, setCardType] = useState();
  const [deactiveModal, setDeactiveModal] = useState(false);
  const [amount, setAmount] = useState();
  const [rechargeModal, setRechargeModal] = useState(false);
  const [rechargeSucessModal, setRechargeSucessModal] = useState(false);
  const [rechargeOrderId, setRechargeOrderId] = useState(null);

  // -----------------------------
  // Load Razorpay script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // -----------------------------
  // Load initial data
  useEffect(() => {
    fetchTagDetails();
    fetchTagHistory();
    fetchTagList();
    clearPreCart();

    connectWebSocket()
  }, []);

  
  // -----------------------------
  // ✅ WebSocket for live payment updates
// -----------------------------
// WebSocket function for live payment updates
const connectWebSocket = (orderId) => {
  //if (!orderId) return;

  //console.log("🔌 Connecting WebSocket for order:", orderId);
  const ws = new WebSocket(
    `wss://api-prod.daalchini.co.in/consumerbe/status/payment?order_id=${orderId}`
  );

  ws.onopen = () => {
    //console.log("✅ WebSocket connected:", orderId);
  };

  ws.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
     // console.log("📩 WebSocket Message:", data);

      if (data.success) {
        //toast.success("Recharge successful!", { autoClose: 1000 });
        setRechargeSucessModal(true);
        setRechargeModal(false)
        setLoader(false);
        fetchTagHistory();
        fetchTagDetails();
        ws.close();
      }
    } catch (err) {
      console.error("❌ Error parsing WebSocket message:", err);
    }
  };

  ws.onerror = (error) => {
    //console.error("❌ WebSocket error:", error);
  };

  ws.onclose = () => {
   // console.log("🔴 WebSocket closed");
  };

  // Optional: return the instance if you need to close manually
  return ws;
};


  // -----------------------------
  const showError = (error) => {
    console.error(error);
    setLoader(false);
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      navigate("/login");
    } else {
      toast.error(
        error?.response?.data?.status?.message || "Something went wrong",
        { position: "top-right", autoClose: 1000 }
      );
    }
  };

  // -----------------------------
  const fetchTagList = () => {
    const token = localStorage.getItem("UserJWTAuth");
    setLoader(true);

    makeApiRequest({
      url: "/auth/tag/linked",
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: (res) => {
        setLoader(false);
        const tags = res.data.response;
        tags.forEach((tag) => {
          if (tag.uid === localStorage.getItem("TagUUID")) {
            setTagBalance(tag.balance);
            setCardType(tag.cardType);
          }
        });
      },
      handleError: showError,
    });
  };

  // -----------------------------
  const fetchTagDetails = () => {
    const token = localStorage.getItem("UserJWTAuth");
    setLoader(true);

    makeApiRequest({
      url: `/auth/tag/${localStorage.getItem("TagUUID")}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: (res) => {
        setLoader(false);
        setTagDeatils(res.data.response);
      },
      handleError: showError,
    });
  };

  // -----------------------------
  const fetchTagHistory = () => {
    const token = localStorage.getItem("UserJWTAuth");
    const now = new Date();
    const lastMonth = new Date(now);
    lastMonth.setMonth(now.getMonth() - 1);

    const formatDate = (d) =>
      `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")} ${String(d.getHours()).padStart(
        2,
        "0"
      )}:${String(d.getMinutes()).padStart(2, "0")}:${String(
        d.getSeconds()
      ).padStart(2, "0")}`;

    const request = {
      pgId: 11,
      uid: uId,
      from: formatDate(lastMonth),
      to: formatDate(now),
    };

    setLoader(true);
    makeApiRequest({
      url: "/consumer/api/v1/user/order/history",
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      data: request,
      handleSuccess: (res) => {
        setLoader(false);
        setTagHistory(res.data);
      },
      handleError: showError,
    });
  };

  // -----------------------------
  const clearPreCart = () => {
    const token = localStorage.getItem("UserJWTAuth");

    makeApiRequest({
      url: "/consumerbe/api/v2/cart",
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: () => {},
      handleError: showError,
    });
  };

  // -----------------------------
  const addIntoCart = () => {
    if (!amount || amount < 1) {
      toast.error("Please add an amount", {
        position: "top-right",
        autoClose: 1000,
      });
      return;
    }

    setLoader(true);

    const token = localStorage.getItem("UserJWTAuth");
    makeApiRequest({
      url: "/consumerbe/api/v2/cart?machineId=-1",
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      data: [{ slotId: 100, count: amount }],
      handleSuccess: () => {
        setLoader(false);
        createRechargeOrder();
      },
      handleError: showError,
    });
  };

  // -----------------------------
  const createRechargeOrder = () => {
    const token = localStorage.getItem("UserJWTAuth");
    setLoader(true);

    makeApiRequest({
      url: "/consumerbe/api/v2/outlet/-1/order",
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      data: {
        type: "recharge",
        rechargeOptions: { rfidCardId: tagDeatils?.cardId },
      },
      handleSuccess: (res) => {
        setLoader(false);
        const orderId = res?.data?.data?.orderId;
        //console.log("✅ Created Order:", orderId);
        setRechargeOrderId(orderId);
        initiatePayment(orderId);
      },
      handleError: showError,
    });
  };

  // -----------------------------
  const initiatePayment = (orderId) => {
    const token = localStorage.getItem("UserJWTAuth");
    makeApiRequest({
      url: `/consumerbe/api/v2/order/${orderId}/payment`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      data: { pgId: 2 },
      handleSuccess: () => {
        initiateRazorpayPayment(orderId);
         connectWebSocket(orderId)
      },
      handleError: showError,
    });
  };

  // -----------------------------
  // ✅ Razorpay Payment (UPI Only)
  const initiateRazorpayPayment = (orderId) => {
   
    if (!orderId) return;

    const payAmount = amount * 100;
    const options = {
      key: "rzp_live_ZVpG4pXQKTLFCS",
      amount: `${payAmount}`,
      currency: "INR",
      name: "Daalchini",
      description: "Tag Recharge",
      handler: (response) => {
        //console.log("✅ Payment Success:", response);
        //toast.success("Payment successful, waiting for confirmation...");
        connectWebSocket(orderId)
      },
      prefill: {
        email: "info@daalchini.co.in",
        contact: JSON.parse(localStorage.getItem("userDetails"))?.mobileNo,
      },
      method: {
        upi: true,
        card: false,
        netbanking: false,
        wallet: false,
      },
      notes: { order_id: orderId },
      theme: { color: "#432B2B" },
      modal: {
        ondismiss: () => {
          setLoader(false);
          toast.info("Payment cancelled.");
        },
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", (err) => {
      console.error("❌ Payment Failed:", err.error);
      toast.error("Payment failed. Please try again.");
      setLoader(false);
    });
    rzp.open();
  };

  // -----------------------------
  const deactivateTag = () => {
    const token = localStorage.getItem("UserJWTAuth");
    setLoader(true);

    makeApiRequest({
      url: `/auth/tag/${uId}/active`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: () => {
        setLoader(false);
        navigate("/taglist");
      },
      handleError: showError,
    });
  };

  // -----------------------------
  return (
    <TagpayHistory
      tagListHistory={tagListHistory}
      Deactive={deactivateTag}
      deactiveModal={deactiveModal}
      DeactiveModal={() => setDeactiveModal(true)}
      setDeactiveModal={setDeactiveModal}
      setAmount={setAmount}
      amount={amount}
      CreateOrderRecharge={createRechargeOrder}
      setRechargeModal={setRechargeModal}
      rechargeModal={rechargeModal}
      tagBalance={tagBalance}
      cardType={cardType}
      tagDeatils={tagDeatils}
      setRechargeSucessModal={setRechargeSucessModal}
      rechargeSucessModal={rechargeSucessModal}
      AddIntoCart={addIntoCart}
      loader={loader}
    />
  );
};

export default TagpayHistoryContainer;
